import { initClickHandler, initClickHandlerAll } from "../../utils/initClickHandler";
import { loginSignupTemplate } from "./templates";
import { resetPassword } from "./reset";
import { loginAction } from "./login";
import { validateOtp } from "./verify";
import { signupAction } from "./signup";

export default function loginSignupBox(context, loginWrapper) {
    loginWrapper.innerHTML = loginSignupTemplate({ currentUrl: window.location.href });
    addViewEventListener(context, loginWrapper);
}

const addViewEventListener = (context, el) => {
    initClickHandlerAll(el.querySelectorAll(".comment--show_signup"), showSignup);
    initClickHandler(el.querySelector(".comment--show_login"), showLogin);
    initClickHandler(el.querySelector(".comment--show_reset_password"), showReset);
    initClickHandlerAll(el.querySelectorAll(".comment--login--close"), closeForm);
    initClickHandler(el.querySelector(".comment--reset-button"), resetPassword);
    el.querySelector("form.comment--login-form").addEventListener("submit", loginAction(context));
    el.querySelector("form.comment--otp-form").addEventListener("submit", validateOtp(context));
    initClickHandler(el.querySelector(".comment--signup-button"), signupAction);
};

const closeForm = (evnt) => {
    const wrapper = evnt.currentTarget.closest(".login-signup-wrapper");
    wrapper.parentNode.removeChild(wrapper);
};

const showSignup = (evnt) => {
    toggleAuthenticationStep(evnt, ".comment--signup-step1");
};
const showLogin = (evnt) => {
    toggleAuthenticationStep(evnt, ".comment--login");
};
const showReset = (evnt) => {
    toggleAuthenticationStep(evnt, ".comment--reset");
};
const toggleAuthenticationStep = (evnt, targetClassName) => {
    const wrapper = evnt.currentTarget.closest(".login-signup-reset");
    const forms = wrapper.querySelectorAll(
        ".comment--signup-step1, .comment--login, .comment--reset"
    );
    forms.forEach((form) => form.classList.add("hidden"));
    wrapper.querySelector(targetClassName).classList.remove("hidden");
};
